import { breakpointDesktopDefault, Breakpoints } from '@/hooks/useBreakpoint';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerConteudo = styled.div<{ $breakpoint: Breakpoints }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 100vh;

  ${({ theme, $breakpoint }) => {
    return css`
      padding: ${theme.spacing[$breakpoint === 'mobile' ? 4 : 5]}px
        ${theme.spacing[$breakpoint === 'mobile' ? 4 : 8]}px;
      gap: ${theme.spacing[$breakpoint === 'mobile' ? 6 : 8]}px;
    `;
  }};

  ${({ $breakpoint }) => {
    if ($breakpoint === 'mobile') return '';
    return css`
      width: 100%;
      max-width: ${breakpointDesktopDefault.maxWidth}px;
      margin: ${breakpointDesktopDefault.margin};
    `;
  }}
`;

export const ContainerHeaderListagemTitulos = styled.div<{
  $breakpoint: Breakpoints;
}>`
  display: flex;

  ${({ theme, $breakpoint }) => {
    if ($breakpoint === 'desktop') {
      return css`
        flex-direction: row;
        justify-content: space-between;
      `;
    }

    return css`
      flex-direction: column;
      gap: ${theme.spacing[5]}px;
    `;
  }}
`;

export const ContainerListagemTitulos = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[7]}px;
`;
